<template>
    <div class="vpc">
        <div @click="changeTheme('light')" class="vlight focus-s" :class="{'sel': themeKey == 'light'}">
            <svg-icon :fill="themeKey == 'light' ? 'var(--ek-text-color1)' : 'var(--ek-text-color3)'" svgname="ic_sun" :size="14"></svg-icon>
        </div>
        <div @click="changeTheme('dark')" class="vdark focus-s" :class="{'sel': themeKey == 'dark'}">
            <svg-icon :fill="themeKey == 'dark' ? 'var(--ek-text-color1)' : 'var(--ek-text-color3)'" svgname="ic_night" :size="12" ></svg-icon>
        </div>
    </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
export default {
    name: 'ThemeSwitchView',
    components: {
        SvgIcon
    },
    props: {

    },
    data(){
        return {
            themeKey: "light"
        }
    },
    mounted:function(){
        this.themeKey = localStorage.getItem('app_theme')
        if (this.themeKey == null) {
            this.themeKey = "light"
        }
       
    },
    methods:{
        ///改变主题
        changeTheme:function(key){
            if (key == this.themeKey) {
                return
            }
            this.themeKey = this.themeKey == "light" ? "dark" : "light"
            localStorage.setItem('app_theme', this.themeKey)
            window.globalUpdateTheme()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vpc {
    display: flex;
    align-items: center;
    background: var(--ek-card-color2);
    padding-left: 3px;
    padding-right: 3px;
    height: 28px;
    border-radius: 20px;
}
.sel{
    background-color: var(--ek-mainbody-bgcolor);
}
.vlight {
    display: flex;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 30px;
}

.vdark {
    display: flex;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 30px;
}
</style>
